import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Typography from './Typography';

var H2 = function H2(props) {
  return React.createElement(Typography, _extends({
    tagName: "h2"
  }, props, {
    type: "h2"
  }));
};

export default H2;